import { render, staticRenderFns } from "./providerUpstreamStatistics.vue?vue&type=template&id=24c54786&scoped=true&"
import script from "./providerUpstreamStatistics.vue?vue&type=script&lang=ts&"
export * from "./providerUpstreamStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./providerUpstreamStatistics.vue?vue&type=style&index=0&id=24c54786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c54786",
  null
  
)

export default component.exports